import { useContext } from "react";
import { ConfigContext } from "../providers/ConfigContext";
import useMakeApiRequest from "./useMakeApiRequest";

const useMakeWalletRefund = () => {
  const { apiBase } = useContext(ConfigContext);
  const makeApiRequest = useMakeApiRequest("POST");

  const makeRefund = async (walletId: any, transactionId: any, body: any) => await makeApiRequest(`${apiBase}/api/wallets/${walletId}/transactions/${transactionId}/refunds`, body);

  return [makeRefund];
};

export default useMakeWalletRefund;
